import classes from "./ExcelData.module.css";
import Select from "react-select";
import "react-dropdown/style.css";
import { useRef } from "react";
import { useState, useEffect } from "react";

function ExcelData(props) {
  const filteredTitle = props.title.filter((t) => t !== "بخش ها");
  const filteredBody = props.body.filter(
    (b) => b && typeof b === "string" && !b.includes("فارسی")
  );

  const [value, setValue] = useState();
  const [bodyContent, setBodyContent] = useState(filteredBody[0]);

  var dropDownTitle = [];

  for (var i in filteredTitle) {
    dropDownTitle.push({ value: filteredTitle[i], label: filteredTitle[i] });
  }

  useEffect(() => {
    if (value !== undefined) {
      for (var i = 0; i < dropDownTitle.length; i++) {
        if (dropDownTitle[i].value === value.value) {
          setBodyContent(filteredBody[i]);
        }
      }
    }
  }, [value]);

  return (
    <div className={classes.mainText}>
      <div className={classes.dropDown}>
        <Select
          id="select"
          isSearchable={false}
          isDisabled={false}
          isRtl={false}
          className={classes.select}
          onChange={(newValue) => {
            setValue(newValue);
          }}
          options={dropDownTitle}
          defaultValue={dropDownTitle[0]}
          placeholder="انتخاب کنید"
          name="Select"
        />
      </div>

      <div className={classes.mainText}></div>
      <p className={classes.paragraph}>
        {" "}
        {bodyContent
          ? bodyContent
          : "برای موضوع مورد نظر داده ای یافت نشد."}{" "}
      </p>
    </div>
  );
}
export default ExcelData;
